import { getExpressAvatarUserCapping, validateExpressAvatarUserCapping, validatePremiumAvatarUserCapping } from '@/services/api';
import { useAuth } from '@/services/auth';
import { useQuery } from 'react-query';

export const VALIDATE_USER_CAPPING_QUERY_KEY = 'validateUserCapping';
export const VALIDATE_USER_PREMIUM_PLUS_AVATAR_CAPPING_QUERY_KEY = 'validateUserPremiumPlusAvatarCapping';
export const VALIDATE_GET_USER_CAPPING_QUERY_KEY = 'getUserCapping';

export const useValidateUserCapping = () => {
    const { isAnonymous } = useAuth();

    return useQuery(VALIDATE_USER_CAPPING_QUERY_KEY, () => validateExpressAvatarUserCapping(), {
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        staleTime: 1000 * 60 * 5,
        retry: false,
        enabled: !isAnonymous,
    });
};

export const useValidateUserPremiumPlusAvatarCapping = () => {
    return useQuery(VALIDATE_USER_PREMIUM_PLUS_AVATAR_CAPPING_QUERY_KEY, validatePremiumAvatarUserCapping, {
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        staleTime: 1000 * 60 * 5,
        retry: false,
    });
};

export const useGetExpressAvatarUserCapping = () => {
    const { isAnonymous } = useAuth();

    return useQuery(VALIDATE_GET_USER_CAPPING_QUERY_KEY, () => getExpressAvatarUserCapping(), {
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        staleTime: 1000 * 60 * 5,
        retry: false,
        enabled: !isAnonymous,
    });
};
